export default "__VITE_ASSET__CTHgd_y7__"